import React, { useState } from 'react';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import VideoModal from '../../StudyAbroadSteps/whyStudyAbroad/videoModal';

interface BannerProps {
  videoUrl: any;
  thumbnailUrl:string;
}



const Trust: React.FC<BannerProps> = ({ videoUrl,thumbnailUrl }) => {
  const bgImageUrl =thumbnailUrl; // Replace with actual image URL
  const [showModal, setShowModal] = useState(false);
  // const videoUrl = 'https://youtu.be/NSAOrGb9orM';
  return (
    <>
      <section className="mb-3" data-aos="zoom-in">
        <div className="container mx-auto px-4">
          <div className="relative w-full md:[50%] h-[250px] md:h-[400px]   rounded-xl overflow-hidden border border-gray-200">
            <ImageWithBasePath
              source={bgImageUrl}
              alt="banner"
              className="w-full h-auto object-cover" />
            {/* <ImageWithBasePath
              src="assets/img/feature/feature-1.jpg"
              alt="banner"
              className="w-full h-auto object-cover" /> */}
            {/* Play Button */}
            <button
              onClick={() => setShowModal(true)}
              className="absolute inset-0 m-auto flex items-center justify-center w-16 h-16 bg-gray-100 hover:bg-white rounded-full z-10"
            >
              <i className="isax isax-play5" />
            </button>
          </div>
        </div>
      </section>

      <VideoModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        videoUrl={ videoUrl}
      />
    </>
  );
};

export default Trust;
